import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from './Icon';
import { useAuthStore } from '../store/authStore';
import { haptic } from '../utils/haptics';

interface NavItem {
  path: string;
  icon: string;
  iconFilled: string;
  label: string;
  adminOnly?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { path: '/app/home',     icon: 'home',                   iconFilled: 'home',                   label: 'Home' },
  { path: '/app/lists',    icon: 'format_list_bulleted',    iconFilled: 'format_list_bulleted',   label: 'Lists' },
  { path: '/app/calendar', icon: 'calendar_month',          iconFilled: 'calendar_month',         label: 'Calendar' },
  { path: '/app/budget',   icon: 'account_balance_wallet',  iconFilled: 'account_balance_wallet', label: 'Budget', adminOnly: true },
  { path: '/app/chat',     icon: 'chat_bubble',             iconFilled: 'chat_bubble',            label: 'Chat' },
];

const BottomNav: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { family } = useAuthStore();
  const isAdmin = family?.role === 'admin';
  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <nav className="fh-bottom-nav" aria-label="Main navigation" role="navigation">
      <div className="fh-nav-inner">
        {NAV_ITEMS.filter(item => !item.adminOnly || isAdmin).map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => { void haptic('light'); history.push(item.path); }}
              className={`fh-nav-item ${active ? 'fh-nav-active' : ''}`}
              aria-label={item.label}
              aria-current={active ? 'page' : undefined}
            >
              <Icon
                name={active ? item.iconFilled : item.icon}
                size={24}
                className="fh-nav-icon"
                weight={active ? 'fill' : 'duotone'}
              />
              <span className="fh-nav-label">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
